import { STATUS } from '@/constants/status';

export const API_KEY_STATUS = STATUS;

export enum API_KEY_STATUS_CODE_RESULT {
  DELETE_SUCCESS = 'succeed delete api key',
  DELETE_FAILURE = "can't delete api key",
  CREATE_SUCCESS = 'succeed create api key',
  USER_NOT_FOUND = 'not found user',
  WORK_SPACE_NOT_FOUND = 'workspace not found',
  EXCEED_LIMIT = 'api exceed limit',
}
